import { get } from '@/services/http';
import { ReportMetadataModel } from '@/models/report_metadata';
import List from './list';

export class ReportMetadataList extends List<ReportMetadataModel> {
  public async fetch() {
    const res: any = await get(`/template_reports`);
    const templateReports = res.data || [];
    const items = [];
    for (const s of templateReports) {
      const reportMetadata = new ReportMetadataModel();
      reportMetadata.mapData(s);
      items.push(reportMetadata);
    }
    this.items = items;
  }

  public async searchByOpenAI(search: string) {
    const templateReports: ReportMetadataList = new ReportMetadataList();
    try {
      const res: any = await get(`/template_reports/search?keyword=${encodeURIComponent(search)}`);
      for (const s of res.data) {
        const templateReport = new ReportMetadataModel();
        templateReport.mapData(s);
        templateReports.add(templateReport);
      }

    } catch (error: any) {
      if (error.code !== 'ERR_CANCELED') {
        throw(error);
      }
    }
    return templateReports;
  }
}
